module.exports = __webpack_public_path__ + "static/media/republica.d81d41fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/republica.png
// module id = 543
// module chunks = 0